import { h } from 'preact'
import { useEffect } from 'preact/hooks'
import style from 'utils/style'
import Stack from 'components/stack'
import { useSize } from 'utils/dom'
import initReco from 'features/reco/script'
import useSSR from '@core/hooks/useSSR'
import modelTypes from '@constants/modelTypes'

export default function FooterPartners() {
	const partners = style(`partners`)
	const { isDesktop, isMobile } = useSize()
	const { storeId } = useSSR([modelTypes.storeId])
	const showRecoImage = storeId === 1

	useEffect(() => {
		if (showRecoImage) initReco('w-reco-root')
	}, [])

	return (
		<Stack
			className={'partners'}
			gap={isDesktop ? 6 : 5}
			align={'center'}
			justify={'center'}
			as={'section'}
			wrap
			fullWidth
		>
			<img
				className={partners(`image`)}
				alt="Bisnode AA kreditvärdighet"
				width="93"
				height="55"
				src="/Themes/nop-theme-base/dist/images/aa-bisnode.png"
				loading="lazy"
			/>
			<a
				href="https://www.uc.se/risksigill2?showorg=5567607782&language=swe"
				title="Sigillet är utfärdat av UC AB. Klicka på bilden för information om UC:s Riskklasser."
				target="_blank"
				rel="noreferrer nofollow"
			>
				<img
					width="251"
					height="71"
					loading="lazy"
					src="//www.uc.se/ucsigill2/sigill?org=5567607782&product=sla&type=svg&special=null"
					alt="UC kreditsigill"
				/>
			</a>

			{showRecoImage && <div id="w-reco-root" />}
		</Stack>
	)
}
